<script setup lang="ts">
import type { CategoryData } from '../types'
import ToolCard from './ToolCard.vue'

interface Props {
  category: CategoryData
  index: number
  activeCategory?: string
}

const props = defineProps<Props>()
const delay = props.index * 0.1
</script>

<template>
  <div
    :id="`category-${category.category}`"
    class="category-section mb-8 animate-fadeIn scroll-mt-14"
    :style="{ animationDelay: `${delay}s` }"
  >
    <h2 class="text-xl font-semibold text-foreground mb-4 px-2 border-l-4 border-primary">
      {{ category.category }}
    </h2>
    <div
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3"
    >
      <ToolCard
        v-for="(item, itemIndex) in category.children"
        :key="`${category.category}-${itemIndex}`"
        :item="item"
      />
    </div>
  </div>
</template>
